// Generated by `yarn tokens:import --aos-ds` from the Figma component set "Input" (6365:73000). Do not edit.
//
// The "hover" axis is interaction state, so it is not a prop: hover and hovered are `hover:`, pressed is `active:`, focus is `focus:`,
// and disabled is applied in JS because react-native-web renders a div, which
// Tailwind's `disabled:` never matches.

import type { FigmaGlyph } from '../../icons/glyph'

export type ContractProp =
    | { kind: 'enum'; values: readonly string[] }
    | { kind: 'boolean' }
    | { kind: 'text' }
    | { kind: 'instance_swap' }
    // A matrix can carry slots too — Modal/Footer has two.
    | { kind: 'slot' }

export type ContractComposition = { component: string; variants: readonly string[] }

export type ContractVariant = {
    container: string
    label: string
    // The surface, when the paint sits on a child rather than the root:
    // empty for every component that paints its own frame.
    box: string
    // Every named node the variant draws beyond those two, keyed by the
    // name Figma gives it. A key that reads as a value rather than a role
    // means the component is a composition, not a primitive.
    parts: Record<string, string>
    // The shape of every part that is one — a VECTOR drawn on top of
    // something the variant also paints, which the whole-variant `glyph`
    // cannot describe because that one requires no paint at all.
    glyphs: Record<string, FigmaGlyph>
    // The glyph the variant draws, inked separately from the label.
    icon: string
    // Applied in JS: `disabled:` never matches a react-native-web div, and
    // `:visited` exists only on an anchor.
    disabled: string
    visited: string
    // Which of `textStyleIds` each text part is set in. The ids are a set,
    // so a component with two says two exist and not which part uses which.
    partTextStyles: Record<string, string>
    // What this cell instantiates, and which variant of it.
    composes: readonly ContractComposition[]
}

export const inputContract = {
    component: 'Input',
    nodeId: '6365:73000',
    section: '[Web] Primitives',
    // Components a variant instantiates, with the variant keys used.
    // Where one of these carries the component's own paint rather than
    // a glyph, the classes below describe only what is left — Checkbox
    // swaps a whole box here.
    composes: [
        { component: 'AdditionalText', variants: ['variant=default', 'variant=error'] },
        { component: 'Error', variants: [] },
        { component: 'Label', variants: [] },
    ],
    stateAxis: 'hover',
    // Where the caller puts content. One `ReactNode` prop per name.
    slots: [] as readonly string[],
    textStyleIds: ['S:b3f9781c3f24a2a84844e4dd3a95088b476f48d2,'],
    props: {
        content: { kind: 'text' },
        iconLeft: { kind: 'instance_swap' },
        iconRight: { kind: 'instance_swap' },
        showAdditionalText: { kind: 'boolean' },
        showIconLeft: { kind: 'boolean' },
        showIconRight: { kind: 'boolean' },
        showLabel: { kind: 'boolean' },
        showXIconRight: { kind: 'boolean' },
        variant: { kind: 'enum', values: ['not-filled', 'disabled', 'error', 'filled', 'focus'] },
    },
    variants: {
        'variant=disabled': {
            container: 'gap-xs w-[13.625rem] items-start opacity-disabled',
            label: 'text-content-muted text-left',
            icon: '',
            disabled: '',
            visited: '',
            box: 'bg-background-input border-border-subtle border rounded-common px-m py-s h-[2.5rem]',
            parts: {
                'Label': 'px-xs gap-2xs h-[1.25rem] items-center',
                'input':
                    'bg-background-input border-border-subtle border rounded-common px-m py-s gap-m h-[2.5rem] items-center',
                'content': 'gap-s items-center',
                'Help text': 'text-content-muted text-left',
                'right-icons': 'gap-s items-center',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                'Help text': 'S:b3f9781c3f24a2a84844e4dd3a95088b476f48d2,',
            } as Record<string, string>,
            composes: [
                { component: 'AdditionalText', variants: ['variant=default'] },
                { component: 'Label', variants: [] },
            ],
        },
        'variant=error': {
            container: 'group/input gap-xs w-[13.625rem] items-start',
            label: 'text-content-default text-left',
            icon: 'text-status-critical',
            disabled: '',
            visited: '',
            box: 'bg-background-input border-status-critical border-2 rounded-common px-m py-s h-[2.5rem] hover:bg-background-input-hover',
            parts: {
                'Label': 'px-xs gap-2xs h-[1.25rem] items-center',
                'input':
                    'bg-background-input border-status-critical border-2 rounded-common px-m py-s gap-m h-[2.5rem] items-center group-hover/input:bg-background-input-hover',
                'content': 'gap-s items-center',
                'Help text': 'text-content-default text-left',
                'right-icons': 'gap-s items-center',
                'AdditionalText': 'px-xs gap-xs h-[1.25rem] items-center',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                'Help text': 'S:b3f9781c3f24a2a84844e4dd3a95088b476f48d2,',
            } as Record<string, string>,
            composes: [
                { component: 'AdditionalText', variants: ['variant=error'] },
                { component: 'Error', variants: [] },
                { component: 'Label', variants: [] },
            ],
        },
        'variant=filled': {
            container: 'group/input gap-xs w-[13.625rem] items-start',
            label: 'text-content-default text-left',
            icon: 'text-content-default',
            disabled: '',
            visited: '',
            box: 'bg-background-input border-border-subtle border rounded-common px-m py-s h-[2.5rem] hover:bg-background-input-hover hover:border-border-strong',
            parts: {
                'Label': 'px-xs gap-2xs h-[1.25rem] items-center',
                'input':
                    'bg-background-input border-border-subtle border rounded-common px-m py-s gap-m h-[2.5rem] items-center group-hover/input:bg-background-input-hover group-hover/input:border-border-strong',
                'content': 'gap-s items-center',
                'Help text': 'text-content-default text-left',
                'right-icons': 'gap-s items-center',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                'Help text': 'S:b3f9781c3f24a2a84844e4dd3a95088b476f48d2,',
            } as Record<string, string>,
            composes: [
                { component: 'AdditionalText', variants: ['variant=default'] },
                { component: 'Label', variants: [] },
            ],
        },
        'variant=focus': {
            container: 'group/input gap-xs w-[13.625rem] items-start',
            label: 'text-content-default text-left',
            icon: '',
            disabled: '',
            visited: '',
            box: 'bg-background-input border-focus-ring border-2 rounded-common px-m py-s h-[2.5rem] hover:bg-background-input-hover',
            parts: {
                'Label': 'px-xs gap-2xs h-[1.25rem] items-center',
                'input':
                    'bg-background-input border-focus-ring border-2 rounded-common px-m py-s gap-m h-[2.5rem] items-center group-hover/input:bg-background-input-hover',
                'content': 'gap-s items-center',
                'Help text': 'text-content-default text-left',
                'right-icons': 'gap-s items-center',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                'Help text': 'S:b3f9781c3f24a2a84844e4dd3a95088b476f48d2,',
            } as Record<string, string>,
            composes: [
                { component: 'AdditionalText', variants: ['variant=default'] },
                { component: 'Label', variants: [] },
            ],
        },
        'variant=not-filled': {
            container: 'group/input gap-xs w-[13.625rem] items-start',
            label: 'text-content-muted text-left',
            icon: 'text-content-default',
            disabled: '',
            visited: '',
            box: 'bg-background-input border-border-subtle border rounded-common px-m py-s h-[2.5rem] hover:bg-background-input-hover hover:border-border-strong',
            parts: {
                'Label': 'px-xs gap-2xs h-[1.25rem] items-center',
                'input':
                    'bg-background-input border-border-subtle border rounded-common px-m py-s gap-m h-[2.5rem] items-center group-hover/input:bg-background-input-hover group-hover/input:border-border-strong',
                'content': 'gap-s items-center',
                'Help text': 'text-content-muted text-left',
                'right-icons': 'gap-s items-center',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                'Help text': 'S:b3f9781c3f24a2a84844e4dd3a95088b476f48d2,',
            } as Record<string, string>,
            composes: [
                { component: 'AdditionalText', variants: ['variant=default'] },
                { component: 'Label', variants: [] },
            ],
        },
    },
} as const satisfies {
    component: string
    nodeId: string
    section: string
    composes: readonly ContractComposition[]
    stateAxis: string | null
    slots: readonly string[]
    textStyleIds: readonly string[]
    props: Record<string, ContractProp>
    variants: Record<string, ContractVariant>
}
